
namespace TabAurous.Retail {

    @Serenity.Decorators.registerClass()
    export class GiftVoucherSalesDetailsDialog extends Serenity.EntityDialog<GiftVoucherSalesDetailsRow, any> {
        protected getFormKey() { return GiftVoucherSalesDetailsForm.formKey; }
        //protected getIdProperty() { return GiftVoucherSalesDetailsRow.idProperty; }
        protected getLocalTextPrefix() { return GiftVoucherSalesDetailsRow.localTextPrefix; }
        //protected getNameProperty() { return GiftVoucherSalesDetailsRow.nameProperty; }
        //protected getService() { return GiftVoucherSalesDetailsService.baseUrl; }
        //protected getDeletePermission() { return GiftVoucherSalesDetailsRow.deletePermission; }
        //protected getInsertPermission() { return GiftVoucherSalesDetailsRow.insertPermission; }
        //protected getUpdatePermission() { return GiftVoucherSalesDetailsRow.updatePermission; }

        protected form = new GiftVoucherSalesDetailsForm(this.idPrefix);

    }
}